module.exports = __webpack_public_path__ + "static/img/1002.8fd65cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/templates/1002.png
// module id = 731
// module chunks = 0 1 12